import type { FC } from 'react'

import { E_CertificateTypes } from '@/enums'
import { Flex, Button, Spin } from '@/components'
import { useInstructions } from '@/helpers/query/use-instructions'
import logoVkusvillPng from '@/img/logo-vkusvill-buy-cert.png?inline'
import logoMagnitFamilyPng from '@/img/logo-magnit-family.png?inline'
import logoPyaterochkaPng from '@/img/logo-pyaterochka-buy-cert.png?inline'
import { SC_Content, SC_InstructionHeader } from './styled'


interface T_CertificateInstructionProps {
  certificateType: E_CertificateTypes
  categoryId?: number
  actionLabel?: string
  onActionClick: () => void
}

export const CertificateInstruction: FC<T_CertificateInstructionProps> = ({
  certificateType,
  categoryId,
  actionLabel = 'Назад',
  onActionClick,
}) => {
  const {
    data: instruction,
    isLoading,
  } = useInstructions(categoryId)


  return (
    <div style={{ minHeight: 120 }}>
      {isLoading && (
        <Flex justify='center' align='center'>
          <Spin size='large' />
        </Flex>
      )}

      {!isLoading && <>
        <Flex align='center' justify='space-between' style={{ marginBottom: '8px' }}>
          <SC_InstructionHeader>
            <h2>
              {certificateType === E_CertificateTypes.Pyaterochka
                ? 'Сеть магазинов Пятерочка'
                : certificateType === E_CertificateTypes.Magnit
                  ? 'Семья Магнит'
                  : 'Сеть магазинов ВкусВилл'
              }
            </h2>

            <span>Применение сертификатов</span>
          </SC_InstructionHeader>

          <img
            src={
              certificateType === E_CertificateTypes.Pyaterochka
                ? logoPyaterochkaPng
                : certificateType === E_CertificateTypes.Magnit
                  ? logoMagnitFamilyPng
                  : logoVkusvillPng
            }
            style={{ height: '48px' }}
          />
        </Flex>

        <SC_Content
          $brand={certificateType}
          dangerouslySetInnerHTML={{ __html: instruction?.[0].content?.ru ?? '' }}
        />

        <Button type='primary' block onClick={onActionClick}>
          {actionLabel}
        </Button>
      </>}
    </div>
  )
}
